import { render, staticRenderFns } from "./SmallProfileCard.vue?vue&type=template&id=58d2a554&scoped=true&"
import script from "./SmallProfileCard.vue?vue&type=script&lang=js&"
export * from "./SmallProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallProfileCard.vue?vue&type=style&index=0&id=58d2a554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2a554",
  null
  
)

export default component.exports